import React, { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { pickBy } from 'lodash';
import PropTypes from 'prop-types';
import qs from 'qs';

import SubMenuWithDate from './SubMenuWithDate';

import { useWindowSize } from '../../../../../../utils/hooks/useWindowSize';

const SelectRange = ({ currentFilters, filters }) => {
  const location = useLocation();
  const history = useHistory();
  const { width } = useWindowSize();

  const queryString = qs.parse(location.search.slice(1));

  const [showDrop, setShowDrop] = useState(false);
  const [activeFilter, setActiveFilter] = useState(filters?.date_range_filter?.find((item) => item.code === currentFilters?.range));

  const onSelectItem = (key, date) => {
    setActiveFilter(filters?.date_range_filter?.find((item) => item.code === key));
    if (key === 'custom') {
      setShowDrop(false);
    }
    let newQuery = {};
    if (key === 'custom') {
      newQuery = { range: key, date_from: date?.startDate, date_to: date?.endDate };
    } else {
      newQuery = { date_from: null, date_to: null, range: key };
    }

    return history.push({
      pathname: location.pathname,
      search: qs.stringify(pickBy({ ...queryString, ...newQuery })),
    });
  };

  return (
    <ButtonToolbar>
      <DropdownButton
        onToggle={setShowDrop}
        open={showDrop}
        pullRight={width > 767}
        bsStyle="default"
        title={activeFilter.title || ''}
        id="reports-dropdown-selectrange"
      >
        {filters?.date_range_filter?.map((item) => {
          if (item.code === 'custom') {
            return (
              <SubMenuWithDate
                key={item.code}
                element={item}
                filters={{
                  date_range_filter_settings: {
                    default_from: activeFilter.date_from || filters?.date_range_filter_settings?.default_from,
                    default_to: activeFilter.date_to || filters?.date_range_filter_settings?.default_to,
                  },
                }}
                pullRight={width > 767}
                minDate={filters?.date_range_filter_settings?.min_date}
                maxDate={filters?.date_range_filter_settings?.max_date}
                onSelect={onSelectItem}
              />
            );
          }
          return (
            <MenuItem key={item.code} active={item.code === activeFilter?.code} eventKey={item.code} onSelect={onSelectItem}>
              {item.title}
            </MenuItem>
          );
        })}
      </DropdownButton>
    </ButtonToolbar>
  );
};

SelectRange.propTypes = {
  currentFilters: PropTypes.object,
  filters: PropTypes.object,
};

export default SelectRange;
